import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { PageQuickActionAutomationMenuProps } from './PageQuickActionAutomationMenu.ts';

export type { PageQuickActionAutomationMenuProps } from '../src/PageQuickActionAutomationMenu.tsx';
export const PageQuickActionAutomationMenu: LoadableType<PageQuickActionAutomationMenuProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-PageQuickActionAutomationMenu" */ '../src/PageQuickActionAutomationMenu.tsx'
				)
			).PageQuickActionAutomationMenu,
	});
